import { atom } from 'jotai';

export const isSessionSearchBarOpenAtom = atom(false);
